export default __webpack_public_path__ + "images/LC.517e72f.png";